export interface TemplateVariable {
  key: string
  label: string
  builtin: boolean
  coverage?: number
}

export const BUILTIN_VARIABLES: TemplateVariable[] = [
  { key: 'first_name', label: 'First Name', builtin: true, coverage: 100 },
  { key: 'last_name', label: 'Last Name', builtin: true, coverage: 100 },
  { key: 'email', label: 'Email', builtin: true, coverage: 100 },
  { key: 'company', label: 'Company', builtin: true, coverage: 100 },
  { key: 'full_name', label: 'Full Name', builtin: true, coverage: 100 },
]

/** Email del contatto di esempio, uguale a `SAMPLE_CONTACT_EMAIL` del backend (#265). */
export const SAMPLE_CONTACT_EMAIL = 'mario.rossi@acme.com'

export const PREVIEW_DATA: Record<string, string> = {
  first_name: 'Mario',
  last_name: 'Rossi',
  email: SAMPLE_CONTACT_EMAIL,
  company: 'Acme Inc',
  full_name: 'Mario Rossi',
}

/** Regex matching {{key}} or {{key | 'fallback'}} token syntax. */
export const TOKEN_RE = /\{\{\s*(\w+)\s*(?:\|\s*'([^']*)')?\s*\}\}/g

/** L'apostrofo dritto è il delimitatore della grammatica {{var | 'testo'}}. */
export function sanitizeTokenFallback(fallback: string): string {
  return fallback.replace(/'/g, '’')
}

export function formatTokenText(key: string, fallback?: string | null): string {
  return fallback ? `{{${key} | '${sanitizeTokenFallback(fallback)}'}}` : `{{${key}}}`
}

export function renderTemplate(
  html: string,
  data: Record<string, string> = PREVIEW_DATA,
): string {
  return html.replace(TOKEN_RE, (_, key, fallback) => {
    const value = data[key]
    if (value) return value
    if (fallback !== undefined) return fallback
    return `{{${key}}}`
  })
}

/** Una voce di `missing_variables` nella risposta dell'invio di test (#251). */
export interface TestSendMissingVariables {
  step_id: string
  step_order: number
  variables: string[]
}

/** Variabili senza valore in almeno uno step inviato, senza duplicati. */
export function collectMissingVariables(entries: TestSendMissingVariables[] | undefined): string[] {
  return [...new Set((entries ?? []).flatMap((e) => e.variables))].sort()
}
